export const NEW_DILIGENCE_WIZARD_ROUTES = [
  '/new-diligence/client-info',
  '/new-diligence/upload-dataroom',
  '/new-diligence/submit',
];
